import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdWarningAmber } from 'react-icons/md';
import { useLanguage } from '../../context/LanguageContext';

export default function ThresholdAlertModal({ alerts, onClose }) {
    const { t } = useLanguage();

    return (
        <AnimatePresence>
            <motion.div className="modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                <motion.div className="modal" style={{ maxWidth: 480 }} initial={{ opacity: 0, scale: 0.9, y: 30 }} animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.9 }} transition={{ duration: 0.25 }}>

                    <div className="modal-header">
                        <div className="modal-title">
                            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(239,68,68,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--danger)' }}>
                                <MdWarningAmber />
                            </div>
                            {t('thresholdAlertModal.title')}
                        </div>
                    </div>

                    <div className="modal-body">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {alerts.map((a) => (
                                <div key={a.sensorId} style={{
                                    background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.25)',
                                    borderRadius: 10, padding: '12px 14px', fontSize: 13, color: 'var(--text-primary)', lineHeight: 1.5
                                }}>
                                    {a.breach === 'max'
                                        ? t('thresholdAlertModal.maxExceeded', { sensorName: a.sensorName, value: a.value, unit: a.unit, threshold: a.maxThreshold })
                                        : t('thresholdAlertModal.minExceeded', { sensorName: a.sensorName, value: a.value, unit: a.unit, threshold: a.minThreshold })}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="modal-footer" style={{ justifyContent: 'center' }}>
                        <button type="button" className="btn btn-primary" onClick={onClose} style={{ minWidth: 140 }}>
                            {t('thresholdAlertModal.ok')}
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
}
